/**
 * Created with IntelliJ IDEA.
 * User: nzamuruev
 * Date: 03.06.13
 * Time: 10:33
 * To change this template use File | Settings | File Templates.
 */

import { Localize } from "../utils/Localize";

import { AbstractTextContentVO } from "./AbstractTextContentVO";
import { LocalizedTimeFormatVO } from "./LocalizedTimeFormatVO";

/**
 *
 */
export class LocalizedTimeVO extends AbstractTextContentVO {
    public static NAME: string = "LocalizedTimeVO";

    private _seconds: number = NaN;
    private _leadingZero: boolean = false;
    private _trim: number = 0;
    private _templatesSet: LocalizedTimeFormatVO;

    constructor(seconds: number = 0.0, trim: number = 2, leadingZero: boolean = true, templates: LocalizedTimeFormatVO = null) {
        super();

        this._seconds = seconds;
        this._trim = trim;
        this._leadingZero = leadingZero;
        this._templatesSet = templates;
    }

    public get seconds(): number {
        return this._seconds;
    }

    public set seconds(value: number) {
        this._seconds = value;
    }

    public get leadingZero(): boolean {
        return this._leadingZero;
    }

    public set leadingZero(value: boolean) {
        this._leadingZero = value;
    }

    public get trim(): number {
        return this._trim;
    }

    public set trim(value: number) {
        this._trim = value;
    }

    public compose(): string {
        return Localize.time(this._seconds, this._trim, this._leadingZero, this._templatesSet);
    }

    public toString(): string {
        return LocalizedTimeVO.NAME + ", seconds: " + this._seconds + ", trim: " + this._trim + ", leadingZero: " + this._leadingZero;
    }

    public get templatesSet(): LocalizedTimeFormatVO {
        return this._templatesSet;
    }

    public set templatesSet(value: LocalizedTimeFormatVO) {
        this._templatesSet = value;
    }
}
